'use client';

import React from 'react';

import { BREAKPOINTS } from '@repo/ui/queries';
import { H1 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn } from 'styles/layouts';

import { LayoutSwitch } from '../../../styles/queries';
import { ComponentContainer, ComponentWrapper } from '../shared/styles';
import TextBlock from '../shared/TextBlock/TextBlock';

import CarouselScrollableItems from './CarouselScrollableItems';
import { CarouselProps } from './types';

export const Carousel: React.FC<CarouselProps> = ({
  title,
  description,
  items,
  backgroundColor,
}) => {
  return (
    <ComponentWrapper>
      <ComponentContainer>
        <FlexColumn gap="48px">
          <FlexColumn gap="20px">
            <H1 bold as="h2">
              {title}
            </H1>
            {description && <TextBlock text={description} />}
          </FlexColumn>
          <LayoutSwitch
            breakpoints={[BREAKPOINTS.laptopMin]}
            variationProps={[{ props: { gap: 24 } }, { props: { gap: 16 } }]}
          >
            <CarouselScrollableItems
              backgroundColor={backgroundColor}
              gap={24}
              items={items}
            />
          </LayoutSwitch>
        </FlexColumn>
      </ComponentContainer>
    </ComponentWrapper>
  );
};
